<template>
  <div>
    <div class="d-flex mb-3">
      <custom-light-card
        :icon="technicianPosition.icon"
        :specificTitleClasses="item.scheduled ? 'success--text' : ''"
        :status="getStatus(this.item)"
        style="width: 70%;"
        :subtitle="technicianPosition.position"
        :title="item.full_name"
      />
      <div class="mx-auto">
        <v-row class="justify-end" v-if="affectation">
          <v-btn
            class="align-self-end"
            @click="$emit('input', item)"
            color="primary"
            :disabled="isAssigned"
            small
          >
            {{
              isAssigned
                ? generateMessage('tech_search.assigned')
                : generateMessage('tech_search.assign')
            }}
          </v-btn>
        </v-row>
        <v-row
          v-if="
            request.entity_ordo === 'O' &&
              request.property &&
              request.property.request_ordo === 'O' &&
              request.rejected === 'N' &&
              ['1', '2'].includes(request.status)
          "
          class="mt-1 justify-end"
        >
          <LinkToP2O
            :isText="false"
            color="primary"
            :request-id="request.id"
            :is-paused="request.is_paused === 'O'"
            :is-assigned="request.dispatched === 'O'"
            class="mx-2"
          />
        </v-row>
      </div>
    </div>
    <custom-simple-table
      hoverTable
      :item="transformedItem"
      i18-path="tech_search.fields"
      :specificClasses="technicianTableStyle"
      :table-keys="technicianTableKeys"
    >
      <template v-slot:arrayItem="{ item }">
        <div class="d-flex arrayDetails" v-if="item.label">
          <truncate-text-with-hover :text="item.label" :length="25" />
          <v-icon class="ml-1" small>{{ item.icon }}</v-icon>
        </div>
      </template>
    </custom-simple-table>
    <div class="font-weight-bold my-2">
      {{ generateMessage('tech_search.tech_interventions') }}
    </div>

    <loader :is-loading="isLoadingInProgressItvs">
      <v-simple-table
        dense
        class="background"
        v-if="inProgressTechItvs && inProgressTechItvs.length"
      >
        <tbody>
          <tr v-for="(intervention, index) in inProgressTechItvs" :key="index">
            <td class="caption  pa-0 font-weight-bold">
              <intervention-date
                :date="intervention.event_datetime | transformDate"
                :status="intervention | getStatus"
              />
            </td>
            <td class="caption  px-2">
              <truncate-text-with-hover
                :text="intervention.description"
                :length="7"
              />
            </td>
            <td class="caption  pa-0 text-end">
              <truncate-text-with-hover
                :text="
                  `${intervention.property_name}-${intervention.property_code}`
                "
                :length="11"
              />
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div v-else class="caption font-italic">
        {{ generateMessage('tech_search.no_data_in_progress') }}
      </div>
      <loader :is-loading="isLoadingScheduledItvs">
        <v-simple-table
          dense
          class="background"
          v-if="scheduledTechItvs && scheduledTechItvs.length"
        >
          <tbody>
            <tr v-for="(intervention, index) in scheduledTechItvs" :key="index">
              <td class="caption  pa-0 font-weight-bold">
                <intervention-date
                  :date="intervention.event_datetime | transformDate"
                  :status="intervention | getStatus"
                />
              </td>
              <td class="caption  px-2">
                <truncate-text-with-hover
                  :text="intervention.description"
                  :length="7"
                />
              </td>
              <td class="caption  pa-0 text-end">
                <truncate-text-with-hover
                  :text="
                    `${intervention.property_name}-${intervention.property_code}`
                  "
                  :length="11"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <div v-else class="caption font-italic">
          {{ generateMessage('tech_search.no_data_scheduled') }}
        </div>
      </loader>
    </loader>
  </div>
</template>

<script>
import CustomLightCard from '@/components/cards/CustomLightCard';
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import { generateMessage } from '@/utils/i18n';
import {
  getInProgressItvsByTechId,
  getScheduledItvsByTechId,
} from '@/services/services/staffInterventions.service';
import getPosition, {
  getPositions,
} from '@/components/selects/technician/technicianPosition';
import getStatus, {
  transformDate,
} from '@/components/selects/technician/technicianStatus';
import InterventionDate from '@/components/displays/InterventionDate';
import Loader from '@/components/widgets/Loader';
import TruncateTextWithHover from '@/components/tools/TruncateTextWithHover';
import LinkToP2O from '@/components/tools/LinkToP2O';

export default {
  name: 'CustomTechnicianDetails',
  components: {
    CustomLightCard,
    CustomSimpleTable,
    InterventionDate,
    Loader,
    LinkToP2O,
    TruncateTextWithHover,
  },
  props: {
    affectedTech: { type: Object, required: false },
    item: { type: Object, required: true },
    specialTechnicians: { type: Object, required: true },
    request: { type: Object, required: true },
    affectation: { type: Boolean, required: false, default: true },
  },
  computed: {
    isAssigned() {
      return this.affectedTech && this.affectedTech.id === this.item.id;
    },
    technicianPosition() {
      return getPosition(this.item.id, this.specialTechnicians);
    },
    status() {
      return getStatus(this.item);
    },
    technicianTableKeys() {
      const keys = ['roles', 'entity_name', 'phone'];
      if (this.item.company_subcontractor_name) {
        keys.splice(1, 0, 'company_subcontractor_name', 'activity_field');
      }
      return keys;
    },
    technicianTableStyle() {
      return this.item.scheduled
        ? this.technicianTableKeys.map((key) =>
            key !== 'roles' ? 'success--text' : ''
          )
        : [];
    },
    transformedItem() {
      return {
        ...this.item,
        phone: `(${this.item.phone_type}) ${
          this.item.phone && this.item.phone.slice(0, 5) !== 'EMAIL'
            ? this.item.phone
            : this.item.email
        }`,
        roles: this.getPositions(this.item.id, this.specialTechnicians).map(
          (item) => {
            return { icon: item.icon, label: item.position };
          }
        ),
      };
    },
  },
  data: () => ({
    inProgressTechItvs: null,
    isLoadingInProgressItvs: false,
    isLoadingScheduledItvs: false,
    scheduledTechItvs: null,
  }),
  watch: {
    item(val) {
      if (val) {
        this.loadInProgressInterventions(val);
        this.loadScheduledInterventions(val);
      }
    },
  },
  mounted() {
    this.loadInProgressInterventions(this.item);
    this.loadScheduledInterventions(this.item);
  },
  filters: {
    transformDate,
    getStatus,
  },
  methods: {
    generateMessage,
    getPositions,
    getStatus,
    loadInProgressInterventions(val) {
      this.inProgressTechItvs = null;
      this.isLoadingInProgressItvs = true;
      getInProgressItvsByTechId(val.id)
        .then((data) => {
          this.inProgressTechItvs = data;
        })
        .finally(() => {
          this.isLoadingInProgressItvs = false;
        });
    },
    loadScheduledInterventions(val) {
      this.scheduledTechItvs = null;
      this.isLoadingScheduledItvs = true;
      getScheduledItvsByTechId(val.id)
        .then((data) => {
          this.scheduledTechItvs = data;
        })
        .finally(() => {
          this.isLoadingScheduledItvs = false;
        });
    },
  },
};
</script>

<style scoped>
.arrayDetails {
  justify-content: end;
  width: 96%;
}
</style>
